import { React, useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Form, FormElement } from "@progress/kendo-react-form";
import { Checkbox, Input } from "@progress/kendo-react-inputs";

const GroupUserModal = (props) => {
  const { groups } = useSelector(state => state.groupsReducer);
  const { users } = useSelector(state => state.usersReducer);
  const [filter, setFilter] = useState('');
  const [activeUsers, setActiveUsers] = useState([])
  const [selectedSiteNames, setSelectedSiteNames] = useState([]);
  const [massSelectorToggle, setMassSelectorToggle] = useState(false)

  const siteArr = groups.map(g => { return { id: g.site.name, name: g.site.name } });

  const checkboxOnChange = (user) => {
    const index = activeUsers.findIndex(activeUser => {
      return user.id === activeUser.id
    });
    let newActiveUsers = [...activeUsers];
    if (index !== -1) {
      newActiveUsers.splice(index, 1);
      setActiveUsers(newActiveUsers);
    } else {
      setActiveUsers([...activeUsers, user])
    }
  }

  const filterOnChange = (e) => {
    setFilter(e.target.value)
  }

  const submit = (event) => {
    let data = {
      name: props.item.name,
      enabled: true,
      siteId: props.item.site.id,
      users: activeUsers
    }

    props.saveGroup(event, data, props.item.id)
  }

  const filterUsers = () => {
    let enabled = [];
    let disabled = [];
    const filteredUsers = users.filter(user =>
      user?.firstName?.toLowerCase().includes(filter.toLowerCase()) ||
      user?.lastName?.toLowerCase().includes(filter.toLowerCase()) ||
      user?.email?.toLowerCase().includes(filter.toLowerCase()) ||
      user?.county?.toLowerCase().includes(filter.toLowerCase()) ||
      user?.site?.name?.toLowerCase().includes(filter.toLowerCase()) ||
      (user.orgdescription && user.orgdescription.toLowerCase().includes(filter.toLowerCase())) || 
      (user.agency && user.agency.toLowerCase().includes(filter.toLowerCase())))
      .filter(user => selectedSiteNames.length ? selectedSiteNames.some(s => s.name == user.site.name) : true)
      .sort((a, b) => {
        const foundUserA = activeUsers.find(obj => {
          return obj.id === a.id
        });
        const foundUserB = activeUsers.find(obj => {
          return obj.id === b.id
        });

        if (foundUserA) { 
          if (!enabled.includes(a)) {
            enabled.push(a)
          }
        } else if (!disabled.includes(a)) {
          disabled.push(a)
        }

        if (foundUserB) { 
          if (!enabled.includes(b)) {
            enabled.push(b)
          }
        } else if (!disabled.includes(b)) {
          disabled.push(b)
        }

        return (foundUserA == foundUserB ? 0 : (foundUserA? -1 : 1))
      });

    enabled.sort((a, b) => {
      const result = a.lastName.localeCompare(b.lastName);

      return result !== 0 ? result : a.firstName.localeCompare(b.firstName);
    })
    
    disabled.sort((a, b) => {
      const result = a.lastName.localeCompare(b.lastName);

      return result !== 0 ? result : a.firstName.localeCompare(b.firstName);
    })
    return enabled.concat(disabled);
  }

  const selectAll = () => {
    let newActiveUsers = [...activeUsers]
    if (massSelectorToggle) { // Deselect
      if (!filter && !selectedSiteNames.length) { // All
        setActiveUsers([]);
      } else { // Filtered List
        for (let user of filterUsers()) {
          const index = newActiveUsers.findIndex(activeUser => activeUser.id === user.id);
          if (index !== -1) {
            newActiveUsers.splice(index, 1);
          }
        }
        setActiveUsers(newActiveUsers);
      }
    } else { // Select
      if (!filter && selectedSiteNames.length) { // All
        setActiveUsers([...users]);
      } else { // Filtered List
        for (let user of filterUsers()) {
          if (!activeUsers.includes(user)) {
            newActiveUsers.push(user);
          }
        }
        setActiveUsers(newActiveUsers);
      }
    }
  }

  const isAllChecked = () => {
    for (let user of filterUsers()) {
      if (!activeUsers.includes(user)) {
        setMassSelectorToggle(false);
        return false;
      }
    }
    setMassSelectorToggle(true)
    return true;
  }

  useEffect(() => {
    const newActiveUsers = [];
    for (let i = 0; i < users.length; i++) {
      for (let group of users[i].Groups) {
        if (group.id === props.item.id) {
          newActiveUsers.push(users[i]);
          break;
        }
      }
    }
    setActiveUsers(newActiveUsers)
    setMassSelectorToggle(!isAllChecked())
  }, [])
  
  return <Dialog title={'Edit Users'} onClose={props.cancelEdit} className='flo-kendo-dialog'>
    <Form
      onSubmit={props.saveGroup}
      initialValues={props.item}
      render={(formRenderProps) => (
        <FormElement style={styles.formElement}>
          <fieldset className={"k-form-fieldset"} style={{ maxHeight: '600px' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingBottom: '10px' }}>
              <div style={{ paddingTop: '18px', paddingRight: '25px' }}>
                {props.editable && <Button
                  iconClass={`${isAllChecked() ? 'k-icon k-i-checkbox-checked' : 'k-icon k-i-checkbox'}`}
                  className="k-button k-primary"
                  style={{ float: "left" }}
                  onClick={() => selectAll(true)}>
                </Button>}
              </div>
              <Input
                value={filter}
                label="Search"
                onChange={filterOnChange}
                style={{ width: '350px', paddingRight: '20px' }} />
              {
                filter && (
                  <div style={{ paddingTop: '18px', paddingRight: '20px' }}>
                    <Button
                      iconClass={'k-icon k-i-x'}
                      className="k-button k-primary"
                      onClick={() => {
                        setFilter('')
                      }}>
                    </Button>
                  </div>
                )
              }
              <MultiSelect
                className='drawer-multiselect'
                label={"Site Filter"}
                data={siteArr.map(e => e['id'])
                  .map((e, i, final) => final.indexOf(e) === i && i)
                  .filter(obj=> siteArr[obj])
                  .map(e => siteArr[e])}
                style={{ width: '350px' }}
                value={selectedSiteNames}
                onChange={(e) => setSelectedSiteNames(e.value)}
                textField="name"
                dataItemKey="id" />
            </div>
            <div style={{ overflowY: 'auto', height: '375px' }}>
              {
                filterUsers()
                  .map((user) => {
                    const foundUser = activeUsers.find(obj => {
                      return obj.id === user.id
                    });

                    const isChecked = foundUser ? true : false;
                    return (
                      <>
                        <div style={{ paddingLeft: '10px' }}>
                          <Checkbox
                            checked={isChecked}
                            value={isChecked}
                            onChange={() => props.editable ? checkboxOnChange(user) : null}>
                            <div style={{ paddingLeft: '15px', display: 'inline' }}>
                              <span style={{ fontWeight: 'bold' }}>{`${user.lastName}, ${user.firstName}`}</span>
                              <span> - {user.email}</span>
                              {user.agency && (<span style={{ fontStyle: 'italic' }}> ({user.agency})</span>)}
                              {user.orgdescription && (<span style={{ fontStyle: 'italic' }}> [{user.orgdescription}] </span>)}
                              {user?.site?.name && (<span style={{ fontStyle: 'bold' }}> [{user.site.name}] </span>)}
                            </div>
                          </Checkbox>
                        </div>
                      </>
                    )
                  })
              }
            </div>
          </fieldset>
          <div className="k-form-buttons k-justify-content-end">
            {props.editable && <button type={"submit"} className="k-button k-primary" onClick={submit} style={styles.modalBtn}>
              Save
            </button>}
            <button type={"submit"} className="k-button" style={styles.modalBtn} onClick={props.cancelEdit}>
              Cancel
            </button>
          </div>
        </FormElement>
      )}
    />
  </Dialog >
}

const styles = {
  formElement: {
    width: 800,
    overflow: 'none'
  },
  modalBtn: {
    padding: '10px 15px',
  },
}

export default GroupUserModal;